import * as moment from 'moment';

export function toTwelveHourTime(twelveHour: string): string {
  let timeInt = parseInt(twelveHour);
  let minutes;
  if (timeInt >= 24) {
    minutes = twelveHour.split(':')[1];
    let returnTime = `${timeInt - 24}:${minutes} AM`;
    return moment(returnTime, 'hh:mm').format('LT');
  } else {
    return moment(twelveHour, 'hh:mm').format('LT');
  }
}
